import * as angular from 'angular';

class NetworkPointBundleCreateMarketsCtrl implements ng.IController {
    constructor() {}

    public bundleRequest: BundleChangeRequestDto;
    public primaryMarket: boolean;
    public secondaryMarket: boolean;
    public readonly: boolean;

    $onInit() {
        if (this.bundleRequest.availableTradingMarket == 'ALL') {
            this.primaryMarket = true;
            this.secondaryMarket = true;
        } else if (this.bundleRequest.availableTradingMarket == 'PRIMARY') {
            this.primaryMarket = true;
            this.secondaryMarket = false;
        } else if (this.bundleRequest.availableTradingMarket == 'SECONDARY') {
            this.primaryMarket = false;
            this.secondaryMarket = true;
        }
    }

    public changeMarket() {
        if (this.primaryMarket && this.secondaryMarket) {
            this.bundleRequest.availableTradingMarket = 'ALL';
        }
        if (!this.primaryMarket && !this.secondaryMarket) {
            delete this.bundleRequest.availableTradingMarket;
        }
        if (this.primaryMarket && !this.secondaryMarket) {
            this.bundleRequest.availableTradingMarket = 'PRIMARY';
        }
        if (!this.primaryMarket && this.secondaryMarket) {
            this.bundleRequest.availableTradingMarket = 'SECONDARY';
        }
    }
}

angular.module('app').component('pkpNetworkPointBundleCreateMarkets', {
    controller: NetworkPointBundleCreateMarketsCtrl,
    template:
        require('app/network-point-bundle/network-point-bundle-create-markets.component.html'),
    bindings: {
        form: '=',
        readonly: '<',
        bundleRequest: '='
    }
});
